import { v4 as generateUuid } from 'uuid';
import debugLogger from "./debugLogger";
function generateRandomId({
  length = 10,
  prefix = 'node'
} = {}) {
  if (length > 13) {
    debugLogger.warn('The length of `generateRandomId` cannot be greater than 13.');
  }
  const uuidWithoutDash = generateUuid().replace(/-/g, '');
  const randHash = uuidWithoutDash.substr(0, length > 13 ? 13 : length);
  return `${prefix}-${randHash}`;
}
export default generateRandomId;